/**
 * Уведомления на стороне клиента.
 *
 * Категория — единица согласия: отписка от рекламных предложений не должна
 * отключать сообщение «ваша фотосессия готова». Список закрытый: он же
 * перечислен типом в базе, и произвольная строка сюда не попадает.
 */
export const NOTIFICATION_CATEGORIES = [
  'generation',
  'bonus',
  'referral',
  'new_collection',
  'reminder',
  'special_offer',
] as const;

export type NotificationCategory = (typeof NOTIFICATION_CATEGORIES)[number];

export type NotificationConsent = Partial<Record<NotificationCategory, boolean>>;

export interface NotificationPreferences {
  categories: NotificationConsent;
  timezone: string;
  /** Часы, в которые писать нельзя. null — тихих часов нет. */
  quietHours: { start: number; end: number } | null;
}
